// removed by extract-text-webpack-plugin
module.exports = {"base":"Icon_base--3XsZU","bars":"Icon_bars--1dg51 Icon_base--3XsZU","filter":"Icon_filter--3Fkjw Icon_base--3XsZU","info":"Icon_info--3c1th Icon_base--3XsZU","notification":"Icon_notification--RtlQE Icon_base--3XsZU","player":"Icon_player--MXIQA Icon_base--3XsZU","vehicle":"Icon_vehicle--3pha4 Icon_base--3XsZU","warning":"Icon_warning--2l4Mh Icon_base--3XsZU","stats":"Icon_stats--3FfEl Icon_base--3XsZU"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Icon/Icon.css
// module id = 1780
// module chunks = 16